import { render, staticRenderFns } from "./DropdownCreate.vue?vue&type=template&id=b14c2ab6&"
import script from "./DropdownCreate.vue?vue&type=script&lang=js&"
export * from "./DropdownCreate.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports